import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import type { Cultura, InsertCultura } from "@shared/schema";

/** Globais (curadas) + custom da própria org, já ordenadas (ordem, nome). */
export function useCulturas() {
  return useQuery<Cultura[]>({ queryKey: ["/api/culturas"] });
}

export function useCreateCultura() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<InsertCultura>) =>
      apiRequest("POST", "/api/culturas", data).then(r => r.json()),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["/api/culturas"] }),
  });
}

export function useUpdateCultura() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<InsertCultura> }) =>
      apiRequest("PATCH", `/api/culturas/${id}`, data).then(r => r.json()),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["/api/culturas"] }),
  });
}

export function useDeleteCultura() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiRequest("DELETE", `/api/culturas/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["/api/culturas"] }),
  });
}
